const CDN_BASE = 'https://cdn0.worthy.com/assets/images/'

const  CdnPath = function (image_path) {
 return `${CDN_BASE}${image_path}`
}
export default CdnPath